import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import React from 'react';

interface IProps {
  title?: string;
  text: string;
  link?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    padding: 0,
    marginLeft: theme.spacing(1),
    marginBottom: 2,
    color: theme.palette.text.hint,
  },
  title: {
    display: 'block',
    fontWeight: 'bold',
    paddingTop: 2,
    paddingBottom: 6,
  },
}));

export const Help = (props: IProps) => {
  const classes = useStyles();
  const { text, title, link } = props;

  return (
    <Tooltip
      title={
        <div>
          {title && <span className={classes.title}>{title}</span>}
          <span>{text}</span>
        </div>
      }
      placement="bottom"
      arrow
      enterDelay={1000}
    >
      <IconButton
        className={classes.button}
        size="small"
        onClick={() => {
          if (link) {
            window.open(link, '_blank', 'noopener noreferrer');
          }
        }}
        style={{
          cursor: link ? 'pointer' : 'help',
        }}
      >
        <HelpOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
};
